/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I download a YouTube thumbnail?`)
};

const es_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo descargo una miniatura de YouTube?`)
};

const de_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lade ich ein YouTube-Thumbnail herunter?`)
};

const nl_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe download ik een YouTube-thumbnail?`)
};

const fr_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment télécharger une miniature YouTube ?`)
};

const it_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come scarico una miniatura YouTube?`)
};

const pt_br2_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como faço para baixar uma thumbnail do YouTube?`)
};

const pt_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como descarrego uma miniatura do YouTube?`)
};

const ja_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのサムネイルをダウンロードするには？`)
};

const zh_yt_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何下载 YouTube 缩略图？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq1_q", locale)
	if (locale === "en") return en_yt_hub_faq1_q(inputs)
	if (locale === "es") return es_yt_hub_faq1_q(inputs)
	if (locale === "de") return de_yt_hub_faq1_q(inputs)
	if (locale === "nl") return nl_yt_hub_faq1_q(inputs)
	if (locale === "fr") return fr_yt_hub_faq1_q(inputs)
	if (locale === "it") return it_yt_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq1_q(inputs)
	if (locale === "pt") return pt_yt_hub_faq1_q(inputs)
	if (locale === "ja") return ja_yt_hub_faq1_q(inputs)
	return zh_yt_hub_faq1_q(inputs)
};